export default __webpack_public_path__ + "static/media/Rectangle-2.7f37fef8.png";